import React from "react";
import styled from "styled-components";

const Switch = ({ label, value, checked, onChange }) => {
  return (
    <Wrapper>
      <h4>{label}</h4>

      <SwitchWrapper>
        <SwitchBox
          id={value}
          type="checkbox"
          value={value}
          checked={checked || false}
          onChange={onChange}
        />
        <SwitchLabel htmlFor={value} />
      </SwitchWrapper>
    </Wrapper>
  );
};

export default Switch;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 56px;

  h4 {
    font-size: 16px;
    line-height: 24px;
    color: ${(props) => props.theme.primaryTextColor};
  }
`;

const SwitchWrapper = styled.div`
  position: relative;
`;

const SwitchLabel = styled.label`
  position: absolute;
  top: 0;
  left: 0;
  width: 50px;
  height: 30px;
  border-radius: 15px;
  background: #bebebe;
  cursor: pointer;
  &::after {
    content: "";
    display: block;
    border-radius: 50%;
    width: 26px;
    height: 26px;
    margin: 2px 0 0 2px;
    background: #ffffff;
    transition: 0.2s;
  }
`;
const SwitchBox = styled.input`
  opacity: 0;
  z-index: 1;
  width: 50px;
  height: 30px;
  border-radius: 15px;
  &:checked + ${SwitchLabel} {
    background: #004fec;
    transition: linear 0.2s;
    &::after {
      content: "";
      display: block;
      border-radius: 50%;
      width: 26px;
      height: 26px;
      margin-left: 22px;
      transition: 0.2s;
    }
  }
`;
